import { EntityCatalogGraphCard } from '@backstage/plugin-catalog-graph';

export const DiagramTab = () => (
  <EntityCatalogGraphCard height={800} maxDepth={1} />
);
